<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="container-fluid module-container" >


  <div class="content-container"  *ngIf="helperService.user.isIncadea !== '1'; else incadea">
    <div
      class="row"
      *ngIf="userProfile.role.roleId !== 1"
      [ngClass]="{ 'loading-filters': areFiltersLoading }"
    >


      <div class="col-lg-12">
        <!-- contactCenter-->
        <mat-card
          class="filter-section"
          *ngIf="userProfile.role.roleId === 3 || userProfile.role.roleId === 4"
        >

        <section class="loading-container" *ngIf="areFiltersLoading">
          <div  class="pulsing" >
            <mat-spinner [diameter]="50" ></mat-spinner>
          </div>
          <p class="pulsing" >{{ "Searching" | translate }}
            {{ searchedFilterElement | translate }}...</p>
        </section>

          <div class="radiosContainer CCRGRadios">
            <mat-label class="selectBrandLabel"
              >*{{ "SelectBrand" | translate }}</mat-label
            >

            <mat-radio-group
              [(ngModel)]="brandId"
              (ngModelChange)="onBrandIdChange($event)"

            >
              <mat-radio-button
                class="custom-radio"
                *ngFor="let brand of brands$ | async as brands$"
                (click)="selectedBrand = brand"
                [value]="brand.brandId"
              >
                {{ brand.brandName }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="CCRGSearchContainer">
            <div class="dropdownsContainer">

                <mat-form-field>
                  <mat-label class="filters-list-label"
                    >*{{ "City" | translate }}</mat-label
                  >
                  <mat-select
                    [(ngModel)]="cityId"
                    (ngModelChange)="
                      onCityIdChange(userCountryId, brandId, cityId)
                    "
                    [disabled]="isCityFieldDisabled()"
                  >
                    <mat-option
                      *ngFor="let city of cities$ | async"
                      (click)="selectedCity = city"
                      [value]="city.cityId"
                    >
                      {{ city.cityName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <mat-form-field>
                  <mat-label class="filters-list-label"
                    >*{{ "TypeOfService" | translate }}</mat-label
                  >
                  <mat-select
                    [(ngModel)]="typeOfServiceId"
                    [disabled]="isTypeOfServiceDisabled()"
                    (ngModelChange)="
                      onTypeOfServiceIdChange(
                        userCountryId,
                        brandId,
                        cityId,
                        $event
                      )
                    "
                  >
                    <mat-option
                      *ngFor="let typeOfService of typesOfservice$ | async"
                      (click)="selectedTypeOfService = typeOfService"
                      [value]="typeOfService.serviceId"
                    >
                      {{ typeOfService.serviceName | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <mat-form-field>
                  <mat-label class="filters-list-label"
                    >*{{ "Workshop" | translate }}</mat-label
                  >
                  <mat-select
                    [(ngModel)]="workshop"
                    (ngModelChange)="
                      onChangeWorkshop(
                        userCountryId,
                        brandId,
                        cityId,
                        typeOfServiceId,
                        workshop
                      )
                    "
                    [disabled]="isWorkshopDisabled()"
                  >
                    <mat-option
                      *ngFor="let workshop of workshops$ | async"
                      [value]="workshop.workshopId"
                      (click)="selectedWorkshop = workshop"
                    >
                      {{ workshop.workshopName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <mat-form-field>
                  <mat-label class="filters-list-label">{{
                    "Advisor" | translate
                  }}</mat-label>
                  <mat-select
                    [(ngModel)]="advisor"
                    [disabled]="isAdvisorDisabled()"
                  >
                    <!-- No preference option comment while not working -->
                    <!-- <mat-option
                     *ngIf="userProfile.role.roleId === 3 "
                      [value]="0"
                      (click)="selectedAdvisor = undefined"
                    >
                      {{ "NoPreference" | translate }}
                    </mat-option> -->
                    <mat-option
                      *ngFor="let advisor of advisors$ | async"
                      [value]="advisor.advisorId"
                      (click)="selectedAdvisor = advisor"
                    >
                      {{ advisor.advisorFullName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

            </div>

            <div >
              <div  class="searchAndCleanContainer">
                <button

                  class="SearchButton"
                  (click)="onCCRGFilterSearchClick()"
                  [disabled]="isSearchDisabled()"

                >
                  <i class="bi bi-search"></i>
                </button>

                <button

                  class="clearButton"
                  (click)="onClearFilterClick()"
                  [disabled]="isClearDisabled()"

                >
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </mat-card>

        <!-- WorkshopSuperAdmin  -->
        <mat-card
          class="filter-section"
          *ngIf="userProfile.role.roleId === 2 || userProfile.role.roleId === 6"
        >

          <section class="schedulerLoading" *ngIf="areFiltersLoading">
            <div  class="pulsing" >
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing"  >{{ "Searching" | translate }}
              {{ searchedFilterElement | translate }}</p>
          </section>

          <div class="dropdownsContainer">
            <mat-form-field >
              <mat-label class="filters-list-label">*{{
                "Advisor" | translate
              }}</mat-label>
              <mat-select
                [(ngModel)]="advisor"
                (ngModelChange)="onAdvisorChange(advisor)"
              >
                <mat-option
                  *ngFor="let advisor of advisors$ | async"
                  [value]="advisor.advisorId"
                  (click)="selectedAdvisor = advisor"
                >
                  {{ advisor.advisorFullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label class="filters-list-label"
                >*{{ "TypeOfService" | translate }}</mat-label
              >
              <mat-select
                [(ngModel)]="typeOfServiceId"
                [disabled]="isTypeOfServiceAdminDisabled"
                (ngModelChange)="getAdvisorServiceBrands($event)"
              >
                <mat-option
                  *ngFor="let typeOfService of typesOfservice$ | async"
                  [value]="typeOfService.serviceId"
                  (click)="selectedTypeOfService = typeOfService"
                >
                  {{ typeOfService.serviceName | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div class="brandsSearchContainer">
            <div class="brandContainer">
              <mat-label>*{{ "SelectBrand" | translate }}</mat-label>

              <mat-radio-group
                [(ngModel)]="brandId"
                (ngModelChange)="onBrandIdWorkshopChange($event)"
                class="radiosContainer"
              >
                <mat-radio-button
                class="radioTest"
                  *ngFor="let brand of brands$ | async as brands$"
                  [value]="brand.brandId"
                  (click)="selectedBrand = brand"
                >
                  {{ brand.brandName }}
                </mat-radio-button>
              </mat-radio-group>

            </div>

            <div class="searchAndCleanContainer workshopbuttons">
              <button

                class="SearchButton"
                (click)="onWorkshopSuperAdminFilterSearchClick()"
                [disabled]="isSearchWSAsearchDisabled()"
                [ngClass]="{ isDisabled: isSearchWSAsearchDisabled() }"
              >
                <i class="bi bi-search"></i>
              </button>

              <button

                class="clearButton"
                (click)="onClearFilterClick()"
                [disabled]="isClearDisabled()"
                [ngClass]="{ isDisabled: isClearDisabled() }"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <!-- buscador de citas por placa del asesor-->

    <div class="row row-container">
      <div class="col-lg-12">
        <mat-card class="calendar-and-plate-filter-container">
          <div class="row plate-filter-row">
            <div class=" plate-filter-column">
              <mat-form-field>
                <mat-icon matPrefix>
                  <button
                  class="filter-box-button-plate filter-box-button-plate--fill"
                  (click)="onPlateNumberSearchClick()"
                  [disabled]="!plateNumberSearch.trim()"
                  >
                    <i class="bi bi-search"></i>
                  </button>
                </mat-icon>
                <mat-label>{{ "Plate" | translate }}</mat-label>
                <input class="plate-input" matInput type="text" [(ngModel)]="plateNumberSearch" (keyup.enter)="onPlateNumberSearchClick()" />
                <mat-icon matSuffix>
                  <button
                  class="filter-box-button"
                  (click)="onPlateNumberClear()"
                  >
                    <i class="bi bi-x-lg"></i>
                </button>
                </mat-icon>
              </mat-form-field>
            </div>
            <div class=" legend-container-column">

                <div *ngFor="let legend of legends; let index = index">

                  <div class="legend-item">
                    <div
                      class="color-icon"
                      [ngStyle]="{
                        'border-color': legends[index].legendConfig.backcolor,
                        background: legends[index].legendConfig.forecolor
                      }"
                    ></div>
                    <span class="legend-label">{{
                      legends[index].label | translate
                    }}</span>
                  </div>
                </div>

            </div>
          </div>
        </mat-card>



      </div>
    </div>
<div class=" row fullcalendar-calendar">
  <div class="schedulerLoading" *ngIf="isSearchingSchedules">
    <section>
      <div  class="pulsing">
        <mat-spinner [diameter]="50" ></mat-spinner>
      </div>
      <p class="pulsing">{{ "SearchingSchedulesAndAvalability" | translate }}...</p>
    </section>
  </div>
  <span *ngIf="schedulerData$ | async"></span>

  <full-calendar  style="height: 76vh; width: auto; font-family: ITCAvantGarden; margin:1rem" *ngIf="!isSearchingSchedules"
  [options]="calendarOptions" [events]="schedulerEvents"  [ngClass]="{schedulerNotClickable: displayDefaultLegends}"
  >
  </full-calendar></div>


  </div>
  <ng-template #incadea>
    <app-i-scheduling></app-i-scheduling>
  </ng-template>
</div>

